module.exports = __webpack_public_path__ + "img/A58A0568_min.109dcb88.jpg";